import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MAT_MOMENT_DATE_FORMATS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatDatepicker, MatDatepickerInput, MatDatepickerToggle } from '@angular/material/datepicker';
import { default as moment } from 'moment';
import 'moment/locale/cs';
import 'moment/locale/da';
import 'moment/locale/de';
import 'moment/locale/en-gb';
import 'moment/locale/es';
import 'moment/locale/fi';
import 'moment/locale/fr';
import 'moment/locale/hu';
import 'moment/locale/it';
import 'moment/locale/ja';
import 'moment/locale/ko';
import 'moment/locale/nb';
import 'moment/locale/nl';
import 'moment/locale/pl';
import 'moment/locale/pt';
import 'moment/locale/pt-br';
import 'moment/locale/ro';
import 'moment/locale/ru';
import 'moment/locale/sk';
import 'moment/locale/sr';
import 'moment/locale/sv';
import 'moment/locale/tr';
import 'moment/locale/uk';
import 'moment/locale/zh-cn';

/*
 * Because of https://github.com/angular/components/issues/28263#issuecomment-1883191079
 * we need to import every locale individually. See https://momentjs.com/docs/#/use-it/typescript/
 * Currently this is only needed for de, as "en" is always imported. Again see the first thread for this.
 */

@Component({
    selector: 'osc-datepicker',
    templateUrl: './datepicker.component.html',
    styleUrls: ['./datepicker.component.scss'],
    // should be in module, but not working
    providers: [
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE],
        },
        { provide: MAT_DATE_FORMATS, useValue: MAT_MOMENT_DATE_FORMATS },
    ],
    imports: [MatDatepickerInput, MatDatepickerToggle, MatDatepicker],
})
export class DatepickerComponent implements OnInit, OnChanges {
    @Input() public language = 'en'; // default en, which is mapped to usa date format
    @Input() public placeholderDate!: Date;
    @Input() public set activeDate(value: Date | undefined) {
        this.setDate(value);
    }

    @Input() public labelText!: string;
    @Input() public inputElementId?: string;
    @Output() public dateChange = new EventEmitter<Date | string>();

    public selectedDate!: moment.Moment;

    public constructor(public adapter: DateAdapter<any>) {}

    public ngOnInit() {
        this.setDate(this.placeholderDate);
    }

    public ngOnChanges(changes: SimpleChanges) {
        if (changes.language) {
            this.adapter.setLocale(this.getLocaleByLanguage(this.language));
        }
    }

    public dateChanged(momentDate: moment.Moment) {
        this.dateChange.emit(momentDate ? momentDate.toDate() : '');
    }

    private getLocaleByLanguage(language: string) {
        language = language.toLowerCase();
        switch (language) {
            case 'en_us':
                return 'en';
            case 'en_gb':
                return 'en-gb';
            case 'no_no':
                return 'nb'; // most common norwegian written Language (NO is not a locale known to moment)
            case 'zh_cn':
                return 'zh-cn'; // long name for chinese
            case 'pt_br':
                return 'pt-br'; // long name for brasilian portugese
            default:
                return language.slice(0, language.indexOf('_'));
        }
    }

    private setDate(date?: Date) {
        if (date) {
            this.selectedDate = moment(date);
            this.dateChange.emit(date);
        }
    }
}
